export default "__VITE_ASSET__CKefMxy2__"